//Login is Signin in the website
import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import './Login.css'
import PublicIcon from '@material-ui/icons/Public';
import { Label } from '@material-ui/icons';
import ButtonPrimary from './ButtonPrimary'
import ButtonSecondary from './ButtonSecondary'

import { useState } from 'react';
import { auth } from '../firebase';
import { useDispatch } from 'react-redux';
import { login } from '../features/userSlice';


function Login() {
    //Hooks
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const dispatch = useDispatch()
    const history = useHistory()
    
    const signIn =(e) => {
        e.preventDefault()


        //
        auth.signInWithEmailAndPassword(email, password).then((userAuth) => {
            dispatch(login({
                email: userAuth.user.email, // email is going to be equal to this
                uid: userAuth.user.uid, // uid is give by firebase
                displayName: userAuth.user.displayName,

            })
            )
            history.push('/teslaaccount') // pushes to a different page or different route to the tesla account page 

        })
        // alerts if theres any erros 
        .catch((error => alert(error.message) ));
    }
    return (
        <div className='login'>
            <div className='login__header'>
                <div className='login__logo'>
                    <Link to='/'>
                        <img src='https://assets.website-files.com/5e8fceb1c9af5c3915ec97a0/5ec2f037975ed372da9f6286_Tesla-Logo-PNG-HD.png'
                            alt='' />
                    </Link>
                </div>
                {/* language */}
                <div className='login__language'>
                    <PublicIcon /> <span>en-US</span>

                </div>
            </div>
            {/*  user to login */}
            <div className='login__info'>
                <h1>Sign in</h1>
                {/*  user to enter the info */}
                <form className='login__form'>
                    <label htmlfor="email"> Email Address</label>
                    {/*  target gets what the user is typying and puts it in value email */}
                    <input type="email"
                        id='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label htmlfor="password"> Password</label>
                    {/*  target gets what the user is typying and puts it in value password */}
                    {/*  type is used to hide the password when the user enters it, it will show password  */}
                    <input
                        type="password"
                        id='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                     {/*  The user will submit his user name and password using this button*/}
                    <ButtonPrimary name='Sign In' Type='submit' onClick={signIn}/>
                </form>
                <div className='login__divider'>
                    <hr/> <span>OR</span><hr/>
                </div>
                <Link to="/signup">
                <ButtonSecondary name='Create account'/>
                </Link>
            </div>

        </div>
    )
}

export default Login
